import './index.scss';

(function ($) {
  'use strict';

  const $toggle = $('.js-filter-form-desktop-toggle-btn');
  const $toggleInput = $(`#${$toggle.attr('for')}`);

  $toggleInput
    .off('change')
    .on('change', e => {
      const data = $toggle.data();

      if (e.currentTarget.checked) {
        $toggle.find('span').html(data.openText);
        $toggle.removeClass('q-open');
      } else {
        $toggle.find('span').html(data.closeText);
        $toggle.addClass('q-open');
      }
    });

  $toggleInput.trigger('change');
})(jQuery);
